<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_as1"
      :custom="{ storage: true }"
      export
      :buttons="toolbarButtons"
      :refresh="{ query: RefreshList }"
    />
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      :loading="loading"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :footer-cell-class-name="footerCellClassName"
      :data="tableData"
    >
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入货源单号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入运输单号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="statustype"
          title="状态"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="message"
            placeholder="请输入实际承运人/车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="license_number"
          title="车牌号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="message"
            placeholder="请输入实际承运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="etc_amount"
          title="ETC总额"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入ETC总额" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipper_name"
          title="发货联系人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="message"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipper_phone"
          title="装货电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="message"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="shipper_address"
          title="装货地址"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入合同编号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consignee_name"
          title="卸货联系人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入出发地" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consignee_phone"
          title="收货电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入出发地" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consignee_address"
          title="收货地址"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入出发地" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="sign_time"
          title="卸货时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange1"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="create_time"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('etc_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.page"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.limit"
      :total="listQuery.totalzong"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  components: {},
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      detailFlag: false,
      listQuery: {
        gmtCreatedRange1: "",
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        totalzong: 0,
        sortField: "",
        sortType: ""
      },
      Pagingconf: [],
      toolbarButtons: [
        // {
        //   name: '下拉按钮',
        //   dropdowns: [{
        //       name: '按钮111',
        //       code: 'btn2'
        //     },
        //     {
        //       name: '按钮222',
        //       code: 'btn3'
        //     }
        //   ]
        // }
      ]
    };
  },
  created() {
    this.findList();
    if (this.getLimit("etc_search_button")) {
      this.toolbarButtons.push({
        code: "btn1",
        name: "查询"
      });
    }
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/openInsure",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.loading = false;
          resolve();
        });
      });
    },
    // 获取详情
    funcDetail(code) {
      this.detailFlag = true;
      this.$refs.detailRef.getContract(code);
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.page = currentPage;
      this.listQuery.limit = pageSize;
      this.findList();
    },
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "平均";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.mean(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "和值";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>

<style></style>
